import { Box, Chip, Grid, Typography } from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import PieChart from '@/components/PieChart'
import { pieChartSections } from '@/utils/constants'
import {
  allInOneRecipeChart,
  getAllInOneCeramicBrand,
  getMaskingRecipe,
} from '@/utils/matisseV2/allInOne'

const MaskingPDF = ({ recipe }) => {
  if (recipe?.provided_input?.indication !== 'Veneer on refractory') {
    return null
  }

  const brand = getAllInOneCeramicBrand(recipe)
  const isSingleDentin = recipe?.provided_input?.recipe_type === 'single dentin'
  const regions = pieChartSections.filter((item) =>
    isSingleDentin ? item.key === 'middle' : item,
  )

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      flexGrow={1}
      p={5}
      sx={{ backgroundColor: '#FFF' }}
      id="download-page-0"
    >
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item sm={4}>
          <Box
            sx={{
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={ToothGraphic5}
              alt="Toothimage"
              style={{ width: 233, height: 330 }}
            />
          </Box>
        </Grid>

        <Grid
          item
          sm={8}
          display="flex"
          flexDirection="column"
          sx={{ color: 'black' }}
        >
          <Box display="flex" alignItems="center" m={3}>
            <Typography variant="h5" sx={{ marginRight: 2 }}>
              Masking:
            </Typography>
            {brand && (
              <Chip
                label={brand}
                sx={{
                  backgroundColor: '#F44336',
                  color: '#FFF',
                  borderRadius: '16px',
                }}
              />
            )}
          </Box>

          <Box display="flex" justifyContent="center" gap={4} mt={2}>
            {regions.map(({ key, label }) => {
              const chart = allInOneRecipeChart(
                getMaskingRecipe(
                  recipe,
                  key as 'cervical' | 'middle' | 'incisal',
                ),
              )
              if (!chart.labels.length) return null
              return (
                <Box
                  key={key}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  width="120px"
                >
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    mb={1}
                    color="black"
                  >
                    {label}
                  </Typography>
                  <PieChart
                    labels={chart.labels}
                    values={chart.values as number[]}
                  />
                </Box>
              )
            })}
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          height: '1px',
          backgroundColor: 'black',
          opacity: 1,
          mt: 2,
        }}
      />
    </Box>
  )
}

export default MaskingPDF
